import { handleButtonBackground } from 'components/Button/Button.style'
import styled from 'styled-components'

export const StyledCircle = styled.div<any>`
  width: 100%;
  min-height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledButtonContainer = styled.div<any>`
  max-width: 600px;
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 15px;

  .disabled-subscription-coins-button {
    background-color: ${handleButtonBackground('orange')};
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;

    :hover {
      cursor: default;
      background-color: ${handleButtonBackground('tertiary')};
    }
  }

  .no-coins-button {
    background-color: #d4e5f7;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;

    :hover {
      cursor: default;
    }
  }
`

export const StyledContainer = styled.div<any>`
  height: 430px;
  width: 100%;
  display: flex;
  text-align: center;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 26px;
  h1 {
    margin-top: 28px;
    color: #324245;
    font-size: 20px;
    font-weight: 600;
    align-items: center;
    display: flex;
  }
  h2 {
    color: #92969a;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
  }
  p {
    margin-top: 15px;
    font-size: 14px;
    color: #495057;
  }

  .no-coins-info {
    font-size: 14px;
    color: #495057;
  }

  img {
    width: 68px;
    height: 68px;
  }

  svg#check-mark {
    width: 40px;
    height: 40px;
    margin-right: 15px;
  }

  .MuiButton-containedPrimary {
    margin-top: 20px;
  }
`

export const StyledSummaryContainer = styled.div`
  display: inline-flex;
  padding: 16px 44px 24px 44px;
  border: 1px solid #ededed;
  border-radius: 4px;
  max-height: 215px;
  flex-direction: column;
  max-width: 80%;
  min-width: 420px;
  width: fit-content;
  overflow-y: auto;
  overflow-x: hidden;
  gap: 2px;
  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-track {
    background: none;
  }
  ::-webkit-scrollbar-thumb {
    background: #c8cbcd;
    border-radius: 5px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`

export const StyleProperty = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex: 1;
  width: 100%;
`

export const StyledPropertyLabel = styled.div`
  min-width: 200px;
  max-width: 200px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #495057;
  text-align: left;
  white-space: wrap;
`

export const StyledPropertyValue = styled.div`
  display: flex;
  align-content: center;
  text-align: left;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  color: #495057;
  white-space: wrap;
  min-width: 0;

  img {
    height: 20px;
    width: 20px;
    margin-left: -3px;
    margin-right: 5px;
  }
`

export const StyledContinueButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
